import jQuery from 'jquery';

import JSZip from 'jszip';
import DataTable from 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-select';

DataTable.Buttons.jszip( JSZip );

class DataTables {
	
	constructor() {

	  	this.table = '#table__applications';
		this.status = document.querySelector('#status');
		this.months = document.querySelector('#months');
	}
  
	init() {

		const self = this;

		jQuery.fn.dataTable.ext.search.push(
			function( settings, data, dataIndex ) {
				var statusVal = self.status.value;
				var status = data[6];
		 
				if (
					statusVal === 'Incompleted' &&
					status === 'Incomplete'
				) {
					return true;
				} else if (
					statusVal === 'Completed' &&
					status !== 'Incomplete'
				) {
					return true;
				} else if (
					statusVal === null ||
					statusVal === '' ||
					statusVal === status
				) {
					return true;
				}
				return false;
			}
		);

		jQuery.fn.dataTable.ext.search.push(
			function( settings, data, dataIndex ) {
				var dateVal = self.months.value;
				var date = data[7];
		 
				if (
					dateVal === null ||
					dateVal === '' ||
					dateVal === date.slice(3)
				) {
					return true;
				}
				return false;
			}
		);

		let fileName = 'ct_applications';
		let columnDefs;
		if ( current_brand == 'jjf' ) {
			fileName = 'jjf_applications';
			columnDefs = [
				{
					orderable: false,
					className: 'select-checkbox',
					targets:   0
				},
				{
					target: 8,
					visible: false,
					searchable: false,
				},
				{
					target: 9,
					visible: false,
					searchable: false,
				},
				{
					target: 10,
					visible: false,
					searchable: false,
				},
				{
					target: 11,
					visible: false,
					searchable: false,
				},
				{
					target: 12,
					visible: false,
					searchable: false,
				},
				{
					target: 13,
					visible: false,
					searchable: false,
				},
				{
					target: 14,
					visible: false,
					searchable: false,
				},
				{
					target: 15,
					visible: false,
					searchable: false,
				},
				{
					target: 16,
					visible: false,
					searchable: false,
				}
			];
		} else {
			columnDefs = [ 
				{
					orderable: false,
					className: 'select-checkbox',
					targets:   0
				},
				{
					target: 8,
					visible: false,
					searchable: false,
				},
				{
					target: 9,
					visible: false,
					searchable: false,
				},
				{
					target: 10,
					visible: false,
					searchable: false,
				},
				{
					target: 11,
					visible: false,
					searchable: false,
				},
				{
					target: 12,
					visible: false,
					searchable: false,
				},
				{
					target: 13,
					visible: false,
					searchable: false,
				},
				{
					target: 14,
					visible: false,
					searchable: false,
				},
				{
					target: 15,
					visible: false,
					searchable: false,
				},
				{
					target: 16,
					visible: false,
					searchable: false,
				},
				{
					target: 17,
					visible: false,
					searchable: false,
				},
				{
					target: 18,
					visible: false,
					searchable: false,
				},
				{
					target: 19,
					visible: false,
					searchable: false,
				},
				{
					target: 20,
					visible: false,
					searchable: false,
				},
				{
					target: 21,
					visible: false,
					searchable: false,
				},
				{
					target: 22,
					visible: false,
					searchable: false,
				},
				{
					target: 23,
					visible: false,
					searchable: false,
				},
				{
					target: 24,
					visible: false,
					searchable: false,
				},
				{
					target: 25,
					visible: false,
					searchable: false,
				},
				{
					target: 26,
					visible: false,
					searchable: false,
				},
				{
					target: 27,
					visible: false,
					searchable: false,
				}
			];
		}

		let table = new DataTable( self.table, {
			lengthMenu: [
				[25, 50, -1],
				[25, 50, "All"]
			],
			dom: 'lftip',
			buttons: [
				{
					extend: 'excel',
					text: 'Download Excel',
					filename: fileName + '-' + todaysDate(),
					footer: true
				}
			],
			order: [
				[7, 'desc']
			],
			columnDefs: columnDefs,
			select: {
				style: 'multi',
				selector: 'td:first-child'
			},
			footerCallback: function ( tfoot, data, start, end, display ) {
				var api = this.api();

				var intVal = function (i) {
					return typeof i === 'string' ? i.replace(/[\£R,]/g, '') * 1 : typeof i === 'number' ? i : 0;
				};

				if ( current_brand == 'ct' ) {
					jQuery( api.column( 4 ).footer() ).html(
						api.column( 4 ).data().reduce( function ( a, b ) {
							return intVal( a ) + intVal( b );
						}, 0 )
					);
				}

				if ( current_brand == 'ct' ) {
					for (let i = 15; i < 27; i++) {
						jQuery( api.column( i ).footer() ).html(
							api.column( i ).data().reduce( function ( a, b ) {
								return intVal( a ) + intVal( b );
							}, 0 )
						);
					}
				}
				
				if ( current_brand == 'jjf' ) {
					jQuery( api.column( 5 ).footer() ).html(
						api.column( 5 ).data().reduce( function ( a, b ) {
							return intVal( a ) + intVal( b );
						}, 0 )
					);

					jQuery( api.column( 14 ).footer() ).html(
						api.column( 14 ).data().reduce( function ( a, b ) {
							return intVal( a ) + intVal( b );
						}, 0 )
					);
				}
			}
		});

		table.buttons().container()
    		.prependTo( jQuery('.table__sort' ) );

		table.on("click", "th.select-checkbox", function() {
			if (jQuery("th.select-checkbox").hasClass("selected")) {
				table.rows().deselect();
				jQuery("th.select-checkbox").removeClass("selected");
			} else {
				table.rows().select();
				jQuery("th.select-checkbox").addClass("selected");
			}
		}).on("select deselect", function() {
			if (table.rows({
					selected: true
				}).count() !== table.rows().count()) {
				jQuery("th.select-checkbox").removeClass("selected");
			} else {
				jQuery("th.select-checkbox").addClass("selected");
			}
		});

		jQuery('#status').on('change', function () {
			table.draw();
		});

		jQuery('#months').on('change', function ( ev ) {
			if ('URLSearchParams' in window) {
				var searchParams = new URLSearchParams(window.location.search);
				searchParams.set("month", ev.target.value);
				window.location.search = searchParams.toString();
			}
		});

		function todaysDate() {
			var d = new Date(),
				month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear();

			if (month.length < 2) 
				month = '0' + month;
			if (day.length < 2) 
				day = '0' + day;
		
			return [year, month, day].join('-');
		}
  
	}
  
  }
  
  export default DataTables;
  